class PageLoader
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'page-loader--bound'
            @.$el.classList.add 'page-loader--bound'
            @.InitEvents()
        return
        
    InitEvents: ->
        self = @
        window.addEventListener 'showpageloader', (e) ->
            self.$el.classList.add 'page-loader--shown'
            return

        window.addEventListener 'hidepageloader', (e) ->
            self.$el.classList.remove 'page-loader--shown'
            return
        return

BindPageLoaders = -> 
    document.querySelectorAll '.page-loader:not(.page-loader--bound)'
        .forEach (el) ->
            new PageLoader el
            return
    return

window.addEventListener 'bind-components', BindPageLoaders